import moment from 'moment';
import { message, Modal } from "antd";
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from "react";
import FeatherIcon from 'feather-icons-react';
import { CheckCircleOutlined } from '@ant-design/icons';
import ArrowPipeline from "./ArrowPipelineforDeal";
import { convertCurrency, ExchangeCurrency } from '../../Filters/FilterConditions';
import { setExPoCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchDealDetails, DealUpdate } from '../../../../Api/Services/DealApiService';
import { LostIcon, OnHlodIcon } from '../../../../components/Icons/Icons';
import DefaultPopup from '../../Popup/DefaultMessagePopup'
import DealcreatePopup from '../../Popup/DealCreatePopup'

const DealStageDemo = ({ UrlId, allFieldStructure, commitStatusId, customGroups, customFields, optionsMap, leadStatusData, displayData, setTrigger, getDetailsData, currencySettings, setNaCTrigger, UpdatePs, canUpdateDelete, ApprovalMessage, AutomationMessage, setErrorData, setIsModalVisible1 }) => {
    const engagedIndex = leadStatusData.findIndex(
        (item) => item.optionKey === "onHold"
    );
    const splitIndex = engagedIndex !== -1 ? engagedIndex : leadStatusData.length;
    const stages = leadStatusData.slice(0, splitIndex);
    const extraStages = leadStatusData.slice(splitIndex);
    const localData = useSelector((state) => state.localRedux);
    const dispatch = useDispatch();
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const [current, setCurrent] = useState();
    const [oldPipeline, setOldPipeline] = useState()
    const [OldFixed, setOldFixed] = useState()
    const [disabled, setDisabled] = useState(false);
    const [makeEdit, setMakeEdit] = useState(false);
    const [winProbability, setWinProbability] = useState()
    const [pipeLineField, setPipeLineField] = useState()
    const [messagePopup, setMessagePopup] = useState(false)
    const [dealInitial, setDealInitial] = useState()
    const [dealInitial2, setDealInitial2] = useState()
    // const [roleData, setRoleData] = useState([])
    // const [formDatas, setFormDatas] = useState([])
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    // const [servicesData, setServiceData] = useState([])
    const [Popup, setPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [popupData, setPopupData] = useState()
    const [displayDataToDeal, setDisplayDataToDeal] = useState()
    const [totalSumValues, setTotalSumValues] = useState({
        dealValue: 0,
        // grossdealValue: 0,
        forecastedValue: 0,
        dealprofit: 0
    })
    const ConvertRates = currencySettings?.exchangeRate;
    const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
    const filteredGruop = customGroups.filter((item) => item.value === "dealWonInformation" || item.value === "dealon-HoldInformation" || item.value === "DealLostInformation")
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    // const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    // const isFormDataValid = formDatas.every(formData => {
    //     return requiredFields.every(field => {
    //         const value = formData[field];
    //         return value !== undefined && value !== '';
    //     });
    // });
    // const isservicesDataValid = servicesData.every(formData => {
    //     return Object.values(formData).every(value => value !== undefined && value !== '');
    // });
    function totalCalculation() {
        // const dealValues = displayDataToDeal?.grossDealValue || 0
        // let sum = 0;
        // let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        // if (displayDataToDeal?.subtype === "Product and Services" || displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
        //     if (isFormDataValid || isservicesDataValid) {
        //         if (formDatas.length === 0 && servicesData.length === 0) {
        //             sum = 1 * dealValues;
        //         }
        //         else {
        //             if (formDatas.length > 0) {
        //                 for (let i = 0; i < formDatas.length; i += 1) {
        //                     if (formDatas[i].total !== undefined)
        //                         sum += 1 * formDatas[i].total;
        //                 }
        //             }
        //             else if (!isservicesDataValid) {
        //                 sum = 1 * dealValues;
        //             }
        //             if (servicesData.length > 0) {
        //                 for (let i = 0; i < servicesData.length; i += 1) {
        //                     if (servicesData[i].serviceLineCost !== undefined)
        //                         sum += 1 * servicesData[i].serviceLineCost;
        //                 }
        //             }
        //             else if (!isFormDataValid) {
        //                 sum = 1 * dealValues;
        //             }
        //         }
        //     }
        //     else if (displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
        //         sum = 1 * dealValues;
        //     }
        // }
        // if (displayDataToDeal?.subtype === "Staff Augmentation") {
        //     for (let i = 0; i < roleData.length; i += 1) {
        //         if (roleData[i].totalValue !== undefined)
        //             sum += 1 * roleData[i].totalValue;
        //     }
        // }
        // if (displayDataToDeal?.discount_percentage !== "0" && displayDataToDeal?.discount_percentage !== 0 && displayDataToDeal?.discount_percentage !== "" && displayDataToDeal?.discount_percentage !== null && displayDataToDeal?.discount_percentage !== undefined) {
        //     totalsum = sum * (1 - Number(displayDataToDeal?.discount_percentage) / 100)
        // }
        // else {
        //     totalsum = sum
        // }
        if (winProbability !== undefined && winProbability !== "") {
            if (totalSumValues?.dealValue) {
                const dValue = 1 * totalSumValues.dealValue;
                Fvalue = dValue * (1 * winProbability / 100)
            }
        }
        if (pipeLineField !== "won") {
            if (changeDealMargin !== undefined && changeDealMargin !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin / 100)
                }
            }
        }
        if (pipeLineField === "won") {
            if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin2 / 100)
                }
            }
        }
        setTotalSumValues({
            dealValue: displayDataToDeal?.dealValue || 0,
            grossdealValue: displayDataToDeal?.grossDealValue || 0,
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace),
            dealprofit: profit?.toFixed(CurencyDecimalPlace)
        })
    }
    async function totalCalculationSubmit(pipeline, windata) {
        // const dealValues = displayDataToDeal?.grossDealValue || 0
        // let sum = 0;
        // let totalsum = displayDataToDeal?.dealValue || 0;
        let Fvalue = 0;
        let profit = 0;
        // if (displayDataToDeal?.subtype === "Product and Services" || displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
        //     if (isFormDataValid || isservicesDataValid) {
        //         if (formDatas.length === 0 && servicesData.length === 0) {
        //             sum = 1 * dealValues;
        //         }
        //         else {
        //             if (formDatas.length > 0) {
        //                 for (let i = 0; i < formDatas.length; i += 1) {
        //                     if (formDatas[i].total !== undefined)
        //                         sum += 1 * formDatas[i].total;
        //                 }
        //             }
        //             else if (!isservicesDataValid) {
        //                 sum = 1 * dealValues;
        //             }
        //             if (servicesData.length > 0) {
        //                 for (let i = 0; i < servicesData.length; i += 1) {
        //                     if (servicesData[i].serviceLineCost !== undefined)
        //                         sum += 1 * servicesData[i].serviceLineCost;
        //                 }
        //             }
        //             else if (!isFormDataValid) {
        //                 sum = 1 * dealValues;
        //             }
        //         }
        //     }
        //     else if (displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
        //         sum = 1 * dealValues;
        //     }
        // }
        // if (displayDataToDeal?.subtype === "Staff Augmentation") {
        //     for (let i = 0; i < roleData.length; i += 1) {
        //         if (roleData[i].totalValue !== undefined)
        //             sum += 1 * roleData[i].totalValue;
        //     }
        // }
        // if (displayDataToDeal?.discount_percentage !== "0" && displayDataToDeal?.discount_percentage !== 0 && displayDataToDeal?.discount_percentage !== "" && displayDataToDeal?.discount_percentage !== null && displayDataToDeal?.discount_percentage !== undefined) {
        //     totalsum = sum * (1 - Number(displayDataToDeal?.discount_percentage) / 100)
        // }
        // else {
        //     totalsum = sum
        // }
        if (windata !== undefined && windata !== "") {
            if (totalSumValues?.dealValue) {
                const dValue = 1 * totalSumValues.dealValue;
                Fvalue = dValue * (1 * windata / 100)
            }
        }
        if (pipeline !== "won") {
            if (changeDealMargin !== undefined && changeDealMargin !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin / 100)
                }
            }
        }
        if (pipeline === "won") {
            if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin2 / 100)
                }
            }
        }
        return {
            dealValue: displayDataToDeal?.dealValue || 0,
            grossdealValue: displayDataToDeal?.grossDealValue || 0,
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace),
            dealprofit: profit?.toFixed(CurencyDecimalPlace)
        }
    }
    const isEqual = (a, b) => {
        if (a === b) return true;
        if (typeof a !== typeof b) return false;
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const mapApiResponseToFormValues = (value) => {
    //     return value.products.map((product) => ({
    //         addProductId: product.add_product_id,
    //         productCategory: product.product_category,
    //         dealProductId: product.deal_product_id,
    //         productLicenseSellingPriceUnitMonth: product.product_license_selling_price_unitMonth,
    //         numberOfUnits: product.number_of_units,
    //         licenseDuration: product.license_duration,
    //         total: product.total
    //     }));
    // };
    // const mapApiResponseToServicesValues = (value) => {
    //     return value.service.map((service) => ({
    //         serviceId: service.service_id,
    //         serviceName: service.service_name,
    //         serviceLineId: service.service_line_id,
    //         serviceLineCost: service.service_line_cost,
    //     }));
    // };
    // const mapApiResponseToRoleValues = (value) => {
    //     return value.staffRoles.map((role) => ({
    //         staffRoleId: role.staff_role_id,
    //         addStaffRoleId: role.add_staff_role_id,
    //         roleName: role.roleName,
    //         country: role.country,
    //         rolePerDayRate: role.role_per_day_rate,
    //         startDate: role.start_date,
    //         endDate: role.end_date,
    //         totalValue: role.total_value,
    //     }));
    // };
    async function setInitialData(value) {
        const result = filteredGruop
            .flatMap(group => customFields[group.customFieldGroupId] || [])
            .reduce((acc, attr) => {
                if (attr.customFieldType === "Default") {
                    acc[attr.fieldKey] = displayData?.[attr.fieldKey] ?? null;
                } else {
                    const customValues = displayData?.customFieldValues || [];
                    const itemValue = customValues.find(
                        item => item.fieldId === attr.fieldId
                    );
                    acc[attr.fieldKey] = normalizeValue(itemValue?.value ?? null);
                }
                return acc;
            }, {});
        setDealInitial({
            pipelineStage: normalizeValue(value.pipelineStage),
            dealProfit: normalizeValue(value.dealProfit),
            oldPipelineStage: normalizeValue(value.old_pipeline_stage),
            // dealValue: normalizeValue(value.dealValue),
            expectedDealLength: normalizeValue(value.expectedDealLength),
            // subtype: normalizeValue(value.subtype),
            // discountPercentage: normalizeValue(value.discountPercentage),
            winProbability: normalizeValue(value.winProbability),
            forecastedValue: normalizeValue(value.forecastedValue),
            // grossDealValue: normalizeValue(value.grossDealValue),
            parentDealId: normalizeValue(value.parentDealId),
            ...result
        })
    }
    async function setInitialData2(value) {
        const result = filteredGruop
            .flatMap(group => customFields[group.customFieldGroupId] || [])
            .reduce((acc, attr) => {
                acc[attr.fieldKey] = null;
                return acc;
            }, {});
        setDealInitial2({
            pipelineStage: normalizeValue(value.pipelineStage),
            oldPipelineStage: normalizeValue(value.old_pipeline_stage),
            // dealValue: normalizeValue(value.deal_value),
            winProbability: normalizeValue(value.winProbability),
            forecastedValue: normalizeValue(value.forecastedValue),
            // grossDealValue: normalizeValue(value.gross_deal_value),
            dealProfit: normalizeValue(value.dealProfit),
            commitStatus: normalizeValue(value.commitStatus),
            parentDealId: normalizeValue(value.parentDealId),
            // dealWonReason: null,
            ...result
        })
    }
    const getRecuiredFields = async (dealId, pipleLineName) => {
        let drag = {
            success: false,
            pipelineId: null,
            dealType: "",
            statusss: null,
        };
        const dealresponse = await FetchDealDetails(dealId);
        const response = dealresponse.data
        const isNotEmpty = (value) => value !== "" && value !== undefined && value !== null;
        if (pipleLineName !== "prospecting") {
            if (response.dealTypeName !== "Empanelment") {
                const allRequiredFieldsPresent =
                    [
                        response.subTypeName,
                        response.contactPerson,
                        response.expectedClosureDate,
                        response.winProbability,
                        response.dealValue,
                        response.revenueStartDate,
                        response.revenueEndDate,
                    ].every(isNotEmpty) &&
                    (response.dealTypeName !== "Expansion" || isNotEmpty(response.parentDealId));
                const isCommitRequired = (pipleLineName === "negotiation" || pipleLineName === "won");
                if (allRequiredFieldsPresent) {
                    let statusss;
                    if (isCommitRequired) {
                        if (!isNotEmpty(response.commitStatus)) {
                            statusss = commitStatusId
                        }
                        else {
                            statusss = response.commitStatus
                        }
                    } else {
                        statusss = response.commitStatus
                    }
                    drag = {
                        success: true,
                        pipelineId: response.pipelineStage,
                        dealType: response.dealTypeName,
                        commitStatus: statusss
                    };
                } else {
                    drag = {
                        success: false,
                        pipelineId: response.pipelineStage,
                        dealType: response.dealTypeName,
                    };
                }
            }
            else {
                const expectClosureDate = response.expectedClosureDate;
                const isCommitRequired = (pipleLineName === "negotiation" || pipleLineName === "won");
                if (isNotEmpty(expectClosureDate)) {
                    let statusss;
                    if (isCommitRequired) {
                        if (!isNotEmpty(response.commitStatus)) {
                            statusss = "Soft Commit"
                        }
                        else {
                            statusss = response.commitStatus
                        }
                    } else {
                        statusss = response.commitStatus
                    }
                    drag = {
                        success: true,
                        pipelineId: response.pipelineStage,
                        dealType: response.dealTypeName,
                        commitStatus: statusss
                    };
                }
                else
                    drag = {
                        success: false,
                        pipelineId: response.pipelineStage,
                        dealType: response.dealTypeName,
                    };
            }
        }
        else {
            const isExpansionValid =
                response.dealTypeName !== "Expansion" || isNotEmpty(response.parentDealId);

            drag = {
                success: isExpansionValid,
                pipelineId: response.pipelineStage,
                dealType: response.dealTypeName,
                commitStatus: response.commitStatus
            };
        }
        return drag;
    }
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const handlePipeLineChange = async (pipeLineStage, value, winData, type) => {
        const pipelineOgName = pipeLineStage.find(item => item.customDropdownOptionId === value)
        setCurrent(value)
        setPipeLineField(pipelineOgName.optionKey)
        if (type === "Setting") {
            setWinProbability(winData)
        }
        else {
            setTrigger("")
            setNaCTrigger("trigger")
        }
        if (pipelineOgName.optionKey.toLowerCase() === "onhold" || pipelineOgName.optionKey.toLowerCase() === "lost") {
            setOldPipeline(OldFixed)
        }
        else {
            setOldPipeline(null)
        }
        if (type !== "Setting") {
            setDisabled(true)
            const process = await getRecuiredFields(UrlId[1], pipelineOgName.optionKey)
            const Subcamcualtion = await totalCalculationSubmit(pipelineOgName.optionKey,
                pipelineOgName.optionKey === "won" ? "100" : pipelineOgName.optionKey === "lost" ? "0" : winData)
            let hideMessage;
            if (process.success) {
                const DealValue = Subcamcualtion.dealValue
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.dealValue))
                    : Subcamcualtion.dealValue;
                const DealProfit = Subcamcualtion.dealprofit
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.dealprofit))
                    : Subcamcualtion.dealprofit;
                const GrossDealValue = Subcamcualtion.grossdealValue
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.grossdealValue))
                    : Subcamcualtion.grossdealValue;
                const ForecastedValue = Subcamcualtion.forecastedValue
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.forecastedValue))
                    : Subcamcualtion.forecastedValue;
                // const convertedServicesData = await Promise.all(
                //     servicesData.map(async (service) => {
                //         const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                //             convertCurrency(ConvertRates, Number(service.serviceLineCost))
                //             : service.serviceLineCost
                //         );
                //         return {
                //             ...service,
                //             serviceLineCost: convertedCost.toString(),
                //         };
                //     })
                // );
                // const convertedRoleData = await Promise.all(
                //     roleData.map(async (role) => {
                //         const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                //             ? convertCurrency(ConvertRates, Number(role.rolePerDayRate))
                //             : role.rolePerDayRate);
                //         const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                //             convertCurrency(ConvertRates, Number(role.totalValue))
                //             : role.totalValue);
                //         return {
                //             ...role,
                //             rolePerDayRate: convertedRate.toString(),
                //             totalValue: convertedTotalValue.toString(),
                //         };
                //     })
                // );
                // const convertedFormDatas = await Promise.all(
                //     formDatas.map(async (product) => {
                //         const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                //             ? convertCurrency(ConvertRates, Number(product.productLicenseSellingPriceUnitMonth))
                //             : product.productLicenseSellingPriceUnitMonth);
                //         const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                //             ? convertCurrency(ConvertRates, Number(product.total))
                //             : product.total);
                //         return {
                //             ...product,
                //             productLicenseSellingPriceUnitMonth: convertedPrice.toString(),
                //             total: convertedTotal.toString(),
                //         };
                //     })
                // );
                const formData = {
                    commitStatus:
                        (pipelineOgName.optionKey !== "prospecting" && pipelineOgName.optionKey !== "qualification" && pipelineOgName.optionKey !== "discovery")
                            ? normalizeValue(process.commitStatus) : null,
                    parentDealId: normalizeValue(displayDataToDeal?.dealTypeName === "Expansion" ? displayDataToDeal?.parentDealId : null),
                    // subtype: normalizeValue(displayDataToDeal.subtype),
                    // discountPercentage: normalizeValue(displayDataToDeal.discount_percentage),
                    expectedDealLength: normalizeValue(changeDealMargin),
                    dealProfit: normalizeValue(DealProfit?.toString()),
                    pipelineStage: normalizeValue(value),
                    actualDealMargin: normalizeValue(pipelineOgName.optionKey === "won" ? (changeDealMargin2 && changeDealMargin2 !== "") ? Number(changeDealMargin2) : changeDealMargin : null),
                    oldPipelineStage: normalizeValue((pipelineOgName.optionKey === "onhold" || pipelineOgName.optionKey === "lost") ? oldPipeline : null),
                    dealValue: normalizeValue(DealValue?.toString()),
                    winProbability: normalizeValue(pipelineOgName.optionKey === "won" ? "100" : pipelineOgName.optionKey === "lost" ? "0" : winData),
                    forecastedValue: normalizeValue(ForecastedValue?.toString()),
                    grossDealValue: normalizeValue(GrossDealValue?.toString()),
                }
                // if (displayDataToDeal?.subtype === "Staff Augmentation") {
                //     formData.staffRole = convertedRoleData;
                //     formData.products = [];
                //     formData.services = [];
                // } else if (displayDataToDeal?.subtype === "Product and Services" || displayDataToDeal?.subtype === "Request for Proposal") {
                //     formData.products = convertedFormDatas;
                //     formData.services = convertedServicesData;
                //     formData.staffRole = [];
                // } else {
                //     formData.staffRole = [];
                //     formData.products = [];
                //     formData.services = [];
                // }
                if (pipelineOgName.optionKey !== "won" && pipelineOgName.optionKey !== "lost" && pipelineOgName.optionKey !== "onhold") {
                    hideMessage = message.loading("Loading...", 0);
                    const payload = {
                        parentDealId: normalizeValue(displayDataToDeal?.dealTypeName === "Expansion" ? displayDataToDeal?.parentDealId : null),
                        pipelineStage: normalizeValue(value),
                        oldPipelineStage: normalizeValue((pipelineOgName.optionKey === "onhold" || pipelineOgName.optionKey === "lost") ? oldPipeline : null),
                        // dealValue: normalizeValue(DealValue?.toString()),
                        winProbability: normalizeValue(pipelineOgName.optionKey === "won" ? "100" : pipelineOgName.optionKey === "lost" ? "0" : winData),
                        forecastedValue: normalizeValue(ForecastedValue?.toString()),
                        // grossDealValue: normalizeValue(GrossDealValue?.toString()),
                        dealProfit: normalizeValue(DealProfit?.toString()),
                        commitStatus:
                            (pipelineOgName.optionKey !== "prospecting" && pipelineOgName.optionKey !== "qualification" && pipelineOgName.optionKey !== "discovery")
                                ? normalizeValue(process.commitStatus) : null,
                    }
                    const updatedFields = getChangedFields(payload, dealInitial2);
                    try {
                        const response = await DealUpdate(updatedFields, UrlId[1])
                        if (response.status === 200) {
                            hideMessage();
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                            }
                            else {
                                // eslint-disable-next-line no-lonely-if
                                if (response.data[0].message === AutomationMessage) {
                                    if (pipelineOgName.optionKey === "Won") {
                                        dispatch(setExPoCall(true));
                                        successMessage("Automation rule triggered", response.data[0].message)
                                        setTimeout(() => {
                                            dispatch(setExPoCall(false));
                                        }, 3000);
                                    } else {
                                        successMessage("Automation rule triggered", response.data[0].message)
                                    }
                                }
                                else if (response.data[0].message === ApprovalMessage) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                }
                                else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                                    if (pipelineOgName.optionKey === "Won") {
                                        dispatch(setExPoCall(true));
                                        successMessage("Deal Won", "Deal Closed! Congratulations on winning the deal! Time to celebrate your success")
                                        setTimeout(() => {
                                            dispatch(setExPoCall(false));
                                        }, 3000);
                                    } else {
                                        message.success("Deal pipeline updated successful");
                                    }
                                } else {
                                    message.success("Deal pipeline updated successful");
                                }
                            }
                            setNaCTrigger("CallBack")
                            setTrigger("activity")
                            getDetailsData()
                            setDisabled(false)
                        }
                    } catch (error) {
                        hideMessage();
                        getDetailsData()
                        message.error(error)
                        setDisabled(false)
                    }
                }
                else {
                    setPopup(true)
                    setDisabled(false)
                    setPopupData(formData)
                    setPopupType("Update")
                }
            }
            else {
                setDisabled(false)
                getDetailsData()
                setMessagePopup(true)
            }
        }
    }
    async function setDealCalculation(params) {
        // const formValues = mapApiResponseToFormValues(params);
        // const servicesValues = mapApiResponseToServicesValues(params);
        // const roleValues = mapApiResponseToRoleValues(params)
        // const convertedServicesData = await Promise.all(
        //     servicesValues.map(async (service) => {
        //         const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
        //             ExchangeCurrency(Number(service.serviceLineCost), ConvertRates)
        //             : service.serviceLineCost
        //         );
        //         return {
        //             ...service,
        //             serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
        //         };
        //     })
        // );
        // const convertedFormDatas = await Promise.all(
        //     formValues.map(async (product) => {
        //         const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
        //             ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRates)
        //             : product.productLicenseSellingPriceUnitMonth);
        //         const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
        //             ? ExchangeCurrency(Number(product.total), ConvertRates)
        //             : product.total)
        //         return {
        //             ...product,
        //             productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
        //             total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
        //         };
        //     })
        // );
        // const convertedRoleData = await Promise.all(
        //     roleValues.map(async (role) => {
        //         const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
        //             ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRates)
        //             : role.rolePerDayRate);
        //         const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
        //             ? ExchangeCurrency(Number(role.totalValue), ConvertRates)
        //             : role.totalValue);
        //         return {
        //             ...role,
        //             rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
        //             totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
        //         };
        //     })
        // );
        // setRoleData(convertedRoleData)
        // setServiceData(convertedServicesData)
        // setFormDatas(convertedFormDatas)
        const DealValue = params.dealValue ? await ExchangeCurrency(Number(params.dealValue), ConvertRates) : params.dealValue;
        // const ProfitDealValue = params.dealProfit && params.dealProfit !== "" ? await ExchangeCurrency(Number(params.dealProfit), ConvertRates) : params.dealProfit;
        const GrossDealValue = params.grossDealValue ? await ExchangeCurrency(Number(params.grossDealValue), ConvertRates) : params.grossDealValue;
        // const ForecastedValue = params.forecastedValue ? await ExchangeCurrency(Number(params.forecastedValue), ConvertRates) : params.forecastedValue;
        const updatedPerson = {
            ...params,
            grossDealValue: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
            // dealProfit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
            dealValue: Number(DealValue?.toFixed(CurencyDecimalPlace)),
            // forecastedValue: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
        };
        setDisplayDataToDeal(updatedPerson)
        if (updatedPerson?.pipelineStageName === "Won" || updatedPerson?.pipelineStageName === "Lost") {
            if (Role !== "Administrator") {
                setMakeEdit(true)
            }
            else {
                setMakeEdit(false)
            }
        } else {
            setMakeEdit(false)
        }
        setChangeDealMargin(params.expectedDealLength)
        setChangeDealMargin2(params.actualDealMargin !== undefined && params.actualDealMargin !== null && params.actualDealMargin !== "" ? params.actualDealMargin : params.expected_deal_length)
        setInitialData(params)
        setInitialData2(params)
        handlePipeLineChange(leadStatusData, params.pipelineStage, params.winProbability, "Setting")
        if ((params.pipelineStageName !== "on-Hold" && params.pipelineStageName !== "On-Hold") && params.pipelineStageName !== "Lost") {
            setOldPipeline(params.pipelineStage)
            setOldFixed(params.pipelineStage)
        }
        else {
            setOldPipeline(params.old_pipeline_stage)
            setOldFixed(params.old_pipeline_stage)
        }
    }
    useEffect(() => {
        if (displayData && displayData !== "Create") {
            setCurrent()
            setDealCalculation(displayData)
        }
    }, [displayData])
    useEffect(() => {
        if (displayDataToDeal) {
            totalCalculation()
        }
    }, [winProbability, changeDealMargin, changeDealMargin2, totalSumValues?.dealValue, displayDataToDeal])
    const getDetailsDataFunction = () => {
        setNaCTrigger("CallBack")
        setTrigger("activity")
        getDetailsData()
    }
    const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "pipelineStage")
    const statusDropdown1 = allFieldStructure.find((item) => item.fieldKey === "expectedClosureDate")
    return (
        <>
            <div>
                <div style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    marginBottom: "15px",
                    display: "flex", alignItems: "center", gap: 5
                }}>
                    {statusDropdown?.fieldLabel} {pipeLineField ? (
                        <div className={`table_list_clicks status-text PipeLine${(pipeLineField === "prospecting" || pipeLineField === "qualification") ? "NotQualified" : "Qualified"}`} style={{ fontSize: 10 }}>
                            {(pipeLineField === "prospecting" || pipeLineField === "qualification") ? <span style={{ display: "flex", alignItems: "center", gap: 5 }}> <FeatherIcon size={16} icon="x" />Not Qualified</span> :
                                <span style={{ display: "flex", alignItems: "center", gap: 5 }}> <FeatherIcon size={16} icon="check" />Qualified</span>}</div >
                    ) : null}
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "5px", fontSize: 12 }}>
                    <div>
                        Deal Start Date: {displayDataToDeal?.created_at}
                    </div>
                    <div>
                        {statusDropdown1?.fieldLabel}: {displayDataToDeal?.expectedClosureDate ? moment(displayDataToDeal?.expectedClosureDate).format(profile?.dateFormate ? profile?.dateFormate : "YYYY-MM-DD") : ""}
                    </div>
                </div>
                <ArrowPipeline
                    stages={stages}
                    currentStage={current}
                    onStageClick={(index) => handlePipeLineChange(leadStatusData, index, winProbability, "Changeing")}
                    completedColor="#007bff"
                    upcomingColor="#e0e0e0"
                    textColor="#fff"
                    arrowHeight={40}
                    notchSize={6}
                    disabledItem={disabled}
                    displayData={displayDataToDeal}
                    oldPipeline={oldPipeline}
                    pipeLineStage={leadStatusData}
                    UpdatePs={UpdatePs}
                    canUpdateDelete={canUpdateDelete}
                    makeEdit={makeEdit}
                />
                <div style={{
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 15
                }}>
                    {extraStages.map((item) => {
                        const isCurrent = current === item.customDropdownOptionId;
                        const canEdit = canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId);
                        const isApprovedNone = displayData?.approved_for === "None";
                        const isInteractive = !isCurrent && canEdit && isApprovedNone && !makeEdit && !disabled;

                        return (
                            <div
                                key={item.customDropdownOptionId}
                                className={
                                    isCurrent
                                        ? "status-upadte-arrow-selected"
                                        : !canEdit
                                            ? "status-upadte-arrow2"
                                            : isApprovedNone
                                                ? "status-upadte-arrow"
                                                : "status-upadte-arrow2"
                                }
                                role="button"
                                tabIndex={0}
                                style={{
                                    cursor: isInteractive ? "pointer" : "default",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                onClick={() => {
                                    if (isInteractive) {
                                        handlePipeLineChange(leadStatusData, item.customDropdownOptionId, winProbability, "Changeing");
                                    }
                                }}
                                onKeyDown={(event) => {
                                    if (
                                        isInteractive &&
                                        (event.key === 'Enter' || event.key === ' ')
                                    ) {
                                        handlePipeLineChange(leadStatusData, item.customDropdownOptionId, winProbability, "Changeing");
                                    }
                                }}
                            >
                                {item.optionKey === "onHold" ? (
                                    <OnHlodIcon marginRight={5} width={10} height={15} />
                                ) : (
                                    <LostIcon marginRight={5} width={13} height={15} />
                                )}
                                {item.option}
                            </div>
                        );
                    })}

                </div>
            </div>
            {Popup && <DealcreatePopup Popup={Popup} setPopup={setPopup}
                GetCallback={getDetailsDataFunction}
                popupType={popupType}
                Id={UrlId[1]}
                old={(pipeLineField === "onhold" || pipeLineField === "lost") ? oldPipeline : null}
                pipelineId={current}
                pipeline={pipeLineField}
                dealTypes={displayDataToDeal?.dealTypeName}
                dealDataSet={popupData}
                dealInitialDataset={dealInitial}
                defaultCurrency={currencySettings}
                successMessage={successMessage}
                AutomationMessage={AutomationMessage} setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1}
                ApprovalMessage={ApprovalMessage}
                filteredGruop={filteredGruop}
                customFields={customFields}
                optionsMap={optionsMap}
            />}
            {messagePopup && <DefaultPopup messagePopup={messagePopup} setMessagePopup={setMessagePopup} />}
        </>
    );
};

DealStageDemo.propTypes = {
    UrlId: PropTypes.array.isRequired,
    getDetailsData: PropTypes.func.isRequired,
    leadStatusData: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    currencySettings: PropTypes.object.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    UpdatePs: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
    ApprovalMessage: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
    setTrigger: PropTypes.func.isRequired,
    allFieldStructure: PropTypes.array.isRequired,
    commitStatusId: PropTypes.number.isRequired,
    customGroups: PropTypes.array.isRequired,
    customFields: PropTypes.object.isRequired,
    optionsMap: PropTypes.object.isRequired,
};

export default DealStageDemo;

